import { render, staticRenderFns } from "./PlcColumnsTable.vue?vue&type=template&id=1ba75368&scoped=true"
import script from "./PlcColumnsTable.vue?vue&type=script&lang=js"
export * from "./PlcColumnsTable.vue?vue&type=script&lang=js"
import style0 from "./PlcColumnsTable.vue?vue&type=style&index=0&id=1ba75368&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ba75368",
  null
  
)

export default component.exports